var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ascenti-logo",class:{'ascenti-logo--white': _vm.theme !== 'light' },attrs:{"href":"https://ascenti.co.uk"}},[_vm._v("\n    Ascenti\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }